<template>
  <div class="full-height">
    <div class="position--relative">
      <transition name="fade">
        <v-progress-linear
          v-if="isLoading"
          class="progress-linear--absolute"
          color="warning"
          height="3"
          indeterminate
        />
      </transition>
    </div>

    <transition name="fade">
      <div v-if="isSuccess" class="full-height">
        <div v-if="false">
          <div v-if="items.length" class="table">
            <div v-if="isValidObject(pagination)" class="table__status">
              <strong>{{ firstItemNumber }}</strong>-<strong>{{ lastItemNumber }}</strong> {{ $t('Common.of') }} <strong>{{ pagination.totalElements | formatNumber }}</strong> {{ $t('Common.policies') }}
            </div>

            <v-layout class="table__header" align-center>
              <v-flex class="text-capitalize" xs2>{{ $t('Common.employee') }}</v-flex>
              <v-flex xs1>Status</v-flex>
              <v-flex xs1>Voucher</v-flex>
              <v-flex class="text-capitalize" xs2>{{ $t('Common.categories') }}</v-flex>
              <v-flex class="text-capitalize" xs2>{{ $t('Common.company') }}</v-flex>
              <v-flex xs2>CNPJ</v-flex>
              <v-flex xs2>E. status</v-flex>
            </v-layout>

            <v-list subheader two-line class="table__body">
              <div v-for="(item, i) in items" :key="`tr-${i}`">
                <v-list-tile
                  class="table__body__tr"
                  :class="{ 'table__body__tr--disabled': item.status === 'disabled' }"
                >
                  <v-list-tile-content>
                    <v-list-tile-sub-title>
                      <v-layout align-center>
                        <v-flex xs2>
                          <span :title="item.name" class="text--ellipsis">
                            {{ item.name | ellipsis(25) }}
                          </span>
                        </v-flex>

                        <v-flex xs1>
                          <span
                            class="bullet"
                            :class="[
                              { 'bullet--danger': item.status === 'disabled' },
                              { 'bullet--success': item.status === 'enabled' },
                            ]"
                            :title="item.status === 'disabled' ? $t(`${namespace}.employeeInactiveStatus`) : $t(`${namespace}.employeeActiveStatus`)"
                          >
                            {{ item.status === 'disabled' ? $t(`${namespace}.employeeInactiveStatus`) : $t(`${namespace}.employeeActiveStatus`) }}
                          </span>
                        </v-flex>

                        <v-flex xs1>
                          <span v-if="item.voucherAnalyze">
                            <span :title="`Corp: ${item.voucherAnalyze.corporateVoucher}`" class="text--ellipsis">
                              <span class="gray-6--text">Corp:</span> {{ item.voucherAnalyze.corporateVoucher }}
                            </span>

                            <span :title="`Cache: ${item.voucherAnalyze.voucherUS}`" class="text--ellipsis">
                              <span class="gray-6--text">Cache:</span> {{ item.voucherAnalyze.voucherUS }}
                            </span>
                          </span>
                        </v-flex>

                        <v-flex xs2>
                          <span
                            v-html="getCategories(item.categories)"
                            :title="getCategories(item.categories).replace('<br>', '')"
                            class="text--ellipsis"
                          />
                        </v-flex>

                        <v-flex xs2>
                          <span :title="item.companyName" class="text--ellipsis">
                            {{ item.companyName | ellipsis(25) }}
                          </span>
                        </v-flex>

                        <v-flex xs2>
                          <span :title="item.cnpj | cnpj" class="text--ellipsis">
                            {{ item.cnpj | cnpj }}
                          </span>
                        </v-flex>

                        <v-flex xs2>
                          <div
                            class="company-status__wrapper text--ellipsis"
                            :title="`${item.companyStatus.toLowerCase() === 'ativa' ? $t('Views.CompanyDetailsPage.enabled') : $t(`Views.CompanyDetailsPage.${item.companyStatus.toLowerCase().replace(/\s/g, '')}`)}`"
                          >
                            <span
                              class="company-status__bullet"
                              :class="`company-status__bullet--${item.companyStatus.toLowerCase() === 'ativa' ? 'enabled' : item.companyStatus}`"
                            />
                            <span class="company-status__label">
                              {{
                                item.companyStatus.toLowerCase() === 'ativa'
                                  ? $t('Views.CompanyDetailsPage.enabled')
                                  : $t(`Views.CompanyDetailsPage.${item.companyStatus.toLowerCase().replace(/\s/g, '')}`)
                              }}
                            </span>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider />
              </div>
            </v-list>
          </div>
        </div>

        <v-layout v-if="items.length" class="pa-2" row wrap>
          <v-flex v-for="(item, index) in items" :key="`voucher-${index}`" xs3>
            <VoucherCard
              :data="item"
              :active="Number(voucherActive) === Number(item.employee.id)"
              @openDrawer="openGlobalDrawer"
            />
          </v-flex>
        </v-layout>

        <EmptyState
          v-else
          :image="!cellPhone ? 'usage-policy' : 'phone'"
          :text="!cellPhone ? $t(`${namespace}.emptyStateMessage`) : $t(`${namespace}.phoneNotFoundMessage`)"
        />

        <div v-if="pagination.totalElements > pagination.itemsPerPage" class="text-xs-center">
          <v-container class="px-0">
            <v-pagination
              v-model="pagination.currentPage"
              color="accent"
              :total-visible="totalVisible"
              :length="pagination.totalPages"
              @input="handlePage"
            />
          </v-container>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <v-layout v-if="isFailed" align-center justify-center column fill-height>
        {{ $t('Common.genericErrorMsg') }}<br>
        <a
          :title="$t('Common.tryAgain')"
          class="accent--text"
          @click.prevent="handleReloadData"
        >
          {{ $t('Common.tryAgain') }}.
        </a>
      </v-layout>
    </transition>

    <GlobalDrawer
      :show="globalDrawer.visibility"
      :drawerType="globalDrawer.type"
      :data="globalDrawer.data"
      :filters="globalDrawer.filters"
      @close="closeGlobalDrawer"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isObject, formatNumber, objectToArray } from 'utils/functions'
import EmptyState from 'components/EmptyState'
import VoucherCard from './VoucherCard'
import GlobalDrawer from 'components/globalDrawer'

export default {
  name: 'Table',
  props: {
    items: {
      type: Array,
      required: true
    },
    pagination: {
      type: Object,
      required: true
    },
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    },
    drawerVisibility: {
      type: Boolean
    },
    cellPhone: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EmptyState,
    VoucherCard,
    GlobalDrawer
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims
    }),

    routeId () {
      const { id } = this.$route.params
      return id ? Number(id) : null
    },

    totalVisible () {
      return window.innerWidth <= 420 ? 5 : 7
    },

    firstItemNumber () {
      const { currentPage, itemsPerPage } = this.pagination
      const calc = (currentPage * itemsPerPage) - itemsPerPage + 1
      const item = currentPage === 1 ? 1 : calc
      return formatNumber(item)
    },

    lastItemNumber () {
      const { currentPage, itemsPerPage, totalElements } = this.pagination
      const calc = currentPage * itemsPerPage
      const item = calc > totalElements ? totalElements : calc
      return formatNumber(item)
    },

    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.SearchPhonePage',
      selectedItem: null,
      voucherActive: null,
      globalDrawer: {
        visibility: false,
        type: '',
        data: {}
      }
    }
  },
  methods: {
    isValidObject (val) {
      return isObject(val)
    },

    setVoucherActive (data) {
      this.voucherActive = data && data.employee && data.employee.id
        ? data.employee.id
        : null
    },

    removeVoucherActive (data) {
      this.voucherActive = null
    },

    openGlobalDrawer (data) {
      this.setVoucherActive(data)

      this.globalDrawer = {
        visibility: true,
        type: 'voucher',
        data
      }
    },

    closeGlobalDrawer () {
      this.removeVoucherActive()

      this.globalDrawer = {
        visibility: false,
        type: '',
        data: {}
      }
    },

    companyStatus (companyStatus) {
      const status = {
        enabled: this.$t('Views.CompanyDetailsPage.enabled'),
        ativa: this.$t('Views.CompanyDetailsPage.enabled'),
        disabled: this.$t('Views.CompanyDetailsPage.disable'),
        fraudSuspect: this.$t('Views.CompanyDetailsPage.fraudSuspect'),
        offboarding: this.$t('Views.CompanyDetailsPage.offboarding'),
        pendingEmail: this.$t('Views.CompanyDetailsPage.pendingEmail'),
        empresaemsememail: this.$t('Views.CompanyDetailsPage.pendingEmail'),
        onboarding: this.$t('Views.CompanyDetailsPage.pendingEmail')
      }

      return status[companyStatus.toLowerCase().replace(/\s/g, '')] || null
    },

    getCategoryData (category) {
      /* todo: ridesCategoriesList */
      const cat = objectToArray(this.$store.state.commonConfig.categories).find(item => item.value === category)
      if (cat) return cat.text
    },

    getCategories (categories) {
      const cat = categories.map(category => this.getCategoryData(category)).sort()
      const arr1 = cat.filter((item, index) => index === 0 || index === 1)
      const arr2 = cat.slice(2, cat.length - 1)
      const arr3 = cat[cat.length - 1]
      const br = arr1.length > 1 ? '<br>' : ''
      return cat.length > 1
        ? `${arr1.join(', ')},${br} ${arr2.join(', ')} e ${arr3}`
        : cat.toString()
    },

    handlePage (page) {
      this.closeGlobalDrawer()
      this.$emit('goToPage', page)
    },

    handleReloadData () {
      this.$emit('reloadData')
    }
  },
  watch: {
    selectedCompany () {
      this.closeGlobalDrawer()
    },

    drawerVisibility () {
      this.closeGlobalDrawer()
    }
  }
}
</script>

<style lang="scss" scoped>
.company-status__bullet,
.company-status__label {
  display: inline-block;
  vertical-align: middle;
}

.company-status__label {
  line-height: normal;
}
</style>
